module.exports = __webpack_public_path__ + "img/resource.141dd87.svg";